import { createSelector } from 'reselect';
import { increaseATBButtonOnPdpSelector } from 'selectors/testTarget/offers/increaseATBButtonOnPdp/increaseATBButtonOnPdpSelector';

const showSelector = createSelector(increaseATBButtonOnPdpSelector, increaseATBButtonOnPDP => !!increaseATBButtonOnPDP.show);

export { showSelector };
